export interface Location {
  id: string;
  slug: string;
  city: string;
  region: string;
  address: string;
  postcode: string;
  phone: string;
  phoneFormatted: string;
  website: string;
  googleMapsUrl: string;
  googleMapsEmbed: string;
  lat: number;
  lng: number;
  metaTitle: string;
  metaDescription: string;
}

export const locations: Location[] = [
  {
    id: 'middlesbrough',
    slug: 'middlesbrough',
    city: 'Middlesbrough',
    region: 'Teesside',
    address: '3 Broadgate Rd, Linthorpe',
    postcode: 'TS5 5LR',
    phone: '07482792915',
    phoneFormatted: '07482 792915',
    website: 'https://britfitmobiletyres.co.uk',
    googleMapsUrl: 'https://maps.app.goo.gl/DcedE5894e1EE9QdA',
    googleMapsEmbed: 'https://maps.google.com/maps?q=3+Broadgate+Rd%2C+Linthorpe%2C+Middlesbrough%2C+TS5+5LR&output=embed&z=16',
    lat: 54.564,
    lng: -1.245,
    metaTitle: 'Mobile Tyre Fitting Middlesbrough | BritFit Mobile Tyres TS5',
    metaDescription: 'BritFit Mobile Tyres Middlesbrough — professional mobile tyre fitting, puncture repair and wheel balancing in Middlesbrough, Linthorpe and Teesside. Call 07482 792915.',
  },
  {
    id: 'durham',
    slug: 'durham',
    city: 'Durham',
    region: 'County Durham',
    address: '41 Hornbeam Cl',
    postcode: 'DH1 1EN',
    phone: '07427135061',
    phoneFormatted: '07427 135061',
    website: 'https://britfitmobiletyres.co.uk',
    googleMapsUrl: 'https://maps.app.goo.gl/qAvhSR7C8DTsMecy9',
    googleMapsEmbed: 'https://maps.google.com/maps?q=41+Hornbeam+Cl%2C+Durham%2C+DH1+1EN&output=embed&z=16',
    lat: 54.776,
    lng: -1.578,
    metaTitle: 'Mobile Tyre Fitting Durham | BritFit Mobile Tyres DH1',
    metaDescription: 'BritFit Mobile Tyres Durham — expert mobile tyre fitting, puncture repair and wheel balancing in Durham City and County Durham. Call 07427 135061.',
  },
  {
    id: 'hartlepool',
    slug: 'hartlepool',
    city: 'Hartlepool',
    region: 'County Durham',
    address: '97 Whitby St S',
    postcode: 'TS24 7LH',
    phone: '07472149338',
    phoneFormatted: '07472 149338',
    website: 'https://britfitmobiletyres.co.uk',
    googleMapsUrl: 'https://maps.app.goo.gl/Nz9YGrYwQivGKe2q7',
    googleMapsEmbed: 'https://maps.google.com/maps?q=97+Whitby+St+S%2C+Hartlepool%2C+TS24+7LH&output=embed&z=16',
    lat: 54.686,
    lng: -1.206,
    metaTitle: 'Mobile Tyre Fitting Hartlepool | BritFit Mobile Tyres TS24',
    metaDescription: 'BritFit Mobile Tyres Hartlepool — fast mobile tyre fitting, puncture repair and wheel balancing across Hartlepool and surrounding areas. Call 07472 149338.',
  },
  {
    id: 'hull',
    slug: 'hull',
    city: 'Hull',
    region: 'East Yorkshire',
    address: '26 New George St',
    postcode: 'HU2 8AY',
    phone: '07414217751',
    phoneFormatted: '07414 217751',
    website: 'https://britfitmobiletyres.co.uk',
    googleMapsUrl: 'https://maps.app.goo.gl/G5gs9kM7JDJT5zUG8',
    googleMapsEmbed: 'https://maps.google.com/maps?q=26+New+George+St%2C+Hull%2C+HU2+8AY&output=embed&z=16',
    lat: 53.745,
    lng: -0.336,
    metaTitle: 'Mobile Tyre Fitting Hull | BritFit Mobile Tyres HU2',
    metaDescription: 'BritFit Mobile Tyres Hull — reliable mobile tyre fitting, puncture repair and wheel balancing in Hull and East Yorkshire. Call 07414 217751.',
  },
  {
    id: 'sheffield',
    slug: 'sheffield',
    city: 'Sheffield',
    region: 'South Yorkshire',
    address: '185 Myrtle Rd, Heeley',
    postcode: 'S2 3HH',
    phone: '07450302298',
    phoneFormatted: '07450 302298',
    website: 'https://britfitmobiletyres.co.uk',
    googleMapsUrl: 'https://maps.app.goo.gl/2TYMSjbhRzQqzxkP9',
    googleMapsEmbed: 'https://maps.google.com/maps?q=185+Myrtle+Rd%2C+Heeley%2C+Sheffield%2C+S2+3HH&output=embed&z=16',
    lat: 53.362,
    lng: -1.468,
    metaTitle: 'Mobile Tyre Fitting Sheffield | BritFit Mobile Tyres S2',
    metaDescription: 'BritFit Mobile Tyres Sheffield — professional mobile tyre fitting, puncture repair and wheel balancing in Sheffield, Heeley and South Yorkshire. Call 07450 302298.',
  },
];
